import * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'

import type { Plugin } from './plugin'
export class Selectors {
  /** TODO:  */
  public readonly widgetPreviewLookupById
  /** TODO:  */
  public readonly widgetPreviewLookupByAlias
  /** TODO:  */
  public readonly getWidgetPreview
  /** TODO:  */
  public readonly getWidgetError
  /** TODO:  */
  public readonly getWidgetLoading
  /** TODO:  */
  public readonly currentWidgetPreview
  /** TODO:  */
  public readonly currentWidgetPreviewError
  /** TODO:  */
  public readonly currentWidgetPreviewIsLoading

  constructor(plugin: Plugin) {
    this.widgetPreviewLookupById = plugin.feature.state.project(
      state => state.widgetPreviewLookupById,
    )

    this.widgetPreviewLookupByAlias = plugin.feature.state.project(
      state => state.widgetPreviewLookupByAlias,
    )

    const getLookupEntry = plugin.feature.createSelectorMethod(
      (
        flexibleIdentifier: ents.core.common.FlexibleIdentifier<ec.models.EntityId>,
      ) => {
        ents.core.common.FlexibleIdentifier.validate(flexibleIdentifier)
        const { id, alias } = flexibleIdentifier

        if (id) {
          return this.widgetPreviewLookupById.project(lookup => lookup[id])
            .asSelector
        } else {
          // TODO: Modify FlexibleIdentifier.validate to return
          // discriminated union {id: string} | {alias: string} instead of
          // current flattened type, so we can avoid doing this
          TypeAsserter.assertIsNotNullish(alias)

          return this.widgetPreviewLookupByAlias.project(
            lookup => lookup[alias],
          ).asSelector
        }
      },
    )
    this.getWidgetPreview = plugin.feature.createSelectorMethod(
      (
        flexibleIdentifier: ents.core.common.FlexibleIdentifier<ec.models.EntityId>,
      ) =>
        getLookupEntry(flexibleIdentifier).project(entry => entry?.preview)
          .asSelector,
    )
    this.getWidgetError = plugin.feature.createSelectorMethod(
      (
        flexibleIdentifier: ents.core.common.FlexibleIdentifier<ec.models.EntityId>,
      ) =>
        getLookupEntry(flexibleIdentifier).project(entry => entry?.error)
          .asSelector,
    )

    this.getWidgetLoading = plugin.feature.createSelectorMethod(
      (
        flexibleIdentifier: ents.core.common.FlexibleIdentifier<ec.models.EntityId>,
      ) =>
        getLookupEntry(flexibleIdentifier).project(entry => entry?.isLoading)
          .asSelector,
    )

    const currentWidgetLookupEntry = this.widgetPreviewLookupById.project(
      plugin.collection.plugins.currentEntityPlugin.feature.selectors.getId()
        .asSelector,
      (lookup, id) => (id ? lookup[id] : undefined),
    )
    this.currentWidgetPreview = currentWidgetLookupEntry.project(
      entry => entry?.preview,
    )
    this.currentWidgetPreviewError = currentWidgetLookupEntry.project(
      entry => entry?.error,
    )
    this.currentWidgetPreviewIsLoading = currentWidgetLookupEntry.project(
      entry => entry?.isLoading,
    )
  }
}
